export default "__VITE_ASSET__BgomXXGK__"